<template>
  <div class="EventModal__tags">
    <div class="EventModal__tagLabel">
      {{ tagLabel }}
    </div>
    <div class="EventModal__tagValue">
      <span v-for="(tag, index) in tags" :key="`targetAudience-${index}`">
        {{ tag.title }}<span v-if="index !== tags.length - 1">,</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "EventModalTags",
  props: {
    tagLabel: String,
    tags: Array,
  },
};
</script>

<style lang="scss">
.SkeletonBox-animation {
  background-color: #dddbdd;
  overflow: hidden;
  position: relative;
  vertical-align: middle;

  &::after {
    animation: shimmer 5s infinite;
    background-image: linear-gradient(
      90deg,
      rgba(#fff, 0) 0,
      rgba(#fff, 0.2) 20%,
      rgba(#fff, 0.5) 60%,
      rgba(#fff, 0)
    );
    bottom: 0;
    content: "";
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transform: translateX(-100%);
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
}
</style>
